import React from "react"
import ScrollToTop from "react-scroll-up"
import { Button, Col, Row } from "reactstrap"
import { ArrowUp, Instagram, Youtube } from "react-feather"
import classnames from "classnames"
import Logo from '../../../assets/img/logo/logo-white.png'
import Logo2 from '../../../assets/img/logo/driver-logo.png'
import * as constant from "../../../configs/constant";
import { withRouter } from "react-router-dom";
import { ROUTE_FAQ, ROUTE_FOOTER_REFUND_POLICY } from "../../../configs/constant";
const Footer = props => {
  let footerTypeArr = ["sticky", "static", "hidden"];
  return (
    <footer
      className={classnames("footer footer-light", {
        "footer-static": props.footerType === "static" || !footerTypeArr.includes(props.footerType),
        "d-none": props.footerType === "hidden"
      })}
    >
      <div className={'container'}>
        <Row className={'ft-about-wrapper-top row-margin'}>
          <Col md={12}>
            <p className={'title'}>SAWARI</p>
            <p className={'about-txt'}>Welcome to SAWARI, Sri Lanka's dynamic online marketplace where you can buy, sell, and explore a vast selection of products and taxi services.</p>
          </Col>
          <Col xs={6} className={'ft-about-mid-wrapper f-s'}>
            <div className={'one-s'}>
              <img src={require("../../../assets/img/icons/tel.png")} />
              <p>077 2419992 </p>
            </div>
          </Col>
          <Col xs={6} className={'ft-about-mid-wrapper'}>
            <div className={'second-s'}>
              <img src={require("../../../assets/img/icons/email.png")} />
              <p>info@sawari.lk</p>
            </div>
          </Col>
        </Row>
      </div>
      <hr color={'white'} />
      <div className={'container mb-1'}>
        <Row>
          <Col md={3} className={'ft-about-wrapper p-0 logo-with-social'}>
            <img src={Logo} />
            <div className={'social-media-icons'}>
              {/* <a href={'https://facebook.com'} target={"_blank"}><img src={require("../../../assets/img/icons/fb-icon.png")} /></a>
              <a href={'https://wa.me/+94772419992'} target={"_blank"}><img src={require("../../../assets/img/icons/whatsapp-icon.png")} /></a> */}
              {/*<a href={'https://www.linkedin.com/'} target={"_blank"}><img src={require("../../../assets/img/icons/linkedin-icon.png")} /></a>*/}
              {/*<a href={'https://www.instagram.com'} target={"_blank"}><img src={require("../../../assets/img/icons/insta-icon.png")} /></a>*/}
            </div>
          </Col>
          {/*<Col md={3} className={'ft-sub-wrapper'}>*/}
          {/*  <p>More Features</p>*/}
          {/*  <p>Sell with 2X</p>*/}
          {/*  <p>Membership</p>*/}
          {/*  <p>Ads</p>*/}
          {/*  <p>Promotions</p>*/}
          {/*  <p>Solutions</p>*/}
          {/*</Col>*/}
          <Col className={'ft-sub-wrapper'}>
            <Row className="m-0">
              <Col md={"6"}>
                <p ></p>
                {/*<p className={'link-p'} onClick={()=>props.history.push(constant.BASE_ROUTE_PATH + constant.ROUTE_FOOTER)}>Contact Us</p>*/}
                <p className={'link-p'} onClickTest={() => props.history.push(constant.BASE_ROUTE_PATH + constant.ROUTE_FOOTER)}><a target={"_blank"} href={`https://sawari.lk/pdf/about_us.pdf?a=${new Date().getTime()}`}>About us</a></p>
                <p className={'link-p'} onClickTest={() => props.history.push(constant.BASE_ROUTE_PATH + constant.ROUTE_FOOTER_TNC)}><a target={"_blank"} href={`https://sawari.lk/pdf/terms_and_conditions.pdf?a=${new Date().getTime()}`}>Terms & Conditions</a></p>
                <p className={'link-p'} onClickTest={() => props.history.push(constant.BASE_ROUTE_PATH + constant.ROUTE_FOOTER_POLICIES)}><a target={"_blank"} href={`https://sawari.lk/pdf/policy_statement_of_the_taxi_service_provider.pdf?a=${new Date().getTime()}`}>Policies</a></p>
              </Col>
              <Col md={"6"} className={'ft-sub-wrapper_'}>
                <p ></p>
                <p className={'link-p'} onClickTest={() => props.history.push(constant.BASE_ROUTE_PATH + constant.ROUTE_FOOTER_REFUND_POLICY)}><a target={"_blank"} href={`https://sawari.lk/pdf/refund_and_reward_policy.pdf?a=${new Date().getTime()}`}>Refund Policy</a></p>
                <p className={'link-p'} onClick={() => props.history.push(constant.BASE_ROUTE_PATH + constant.ROUTE_FAQ)}>FAQs</p>
              </Col>
              <Col md={"12"} className="d-flex align-items-center justify-content-center mt-2 mb-2">
                <div className={'social-media-icons'}>
                  <a href={'https://facebook.com/Sawari.Lk'} target={"_blank"}><img src={require("../../../assets/img/icons/fb-icon.png")} /></a>
                  <a href={'https://wa.me/+94772419992'} target={"_blank"}><img src={require("../../../assets/img/icons/whatsapp-icon.png")} /></a>
                  <a href="https://www.tiktok.com/@sawari.driver?_r=1&_t=ZS-93wqF3d0yDX" target={"_blank"}><img src={require("../../../assets/img/icons/tiktok-icon.png")} /></a>
                  <a href={'https://www.youtube.com/@Sawari-Driver'} target={"_blank"}><Youtube size="25" /></a>
                  {/* <a href={'https://www.instagram.com/sawari.lk?igsh=MWd6NmZscWJhZXlncQ%3D%3D&utm_source=qr'} target={"_blank"}><Instagram size="25" /></a> */}
                  <a href={'https://www.instagram.com/sawari.lk01?igsh=MWQ2YTF2NHdqaGtsZg%3D%3D&utm_source=qr'} target={"_blank"}><Instagram size="25" /></a>
                </div>

              </Col>
            </Row>
          </Col>

          <Col md={3} className={'ft-about-wrapper p-0 logo-with-social'}>
            <img src={Logo2} />
            <div className={'social-media-icons opacity-none'}>

            </div>
          </Col>
        </Row>
      </div>
      <p className="mb-0_ clearfix w-100_ text-center footer-credit">
        {/* © {new Date().getFullYear()} */}
        <span className="float-md-left d-block d-md-inline-block w-100">
          {/*ALL RIGHTS RESERVED @ {new Date().getFullYear()}*/}
          All rights reserved @ SAWARI
          {/*  | Developed by<a href={'https://www.webslk.com/'} target={"_blank"}>Web Solutions Lanka</a>*/}
        </span>
      </p>
      {props.hideScrollToTop === false ? (
        <ScrollToTop showUnder={360}>
          <Button color="primary" className="btn-icon scroll-top">
            <ArrowUp size={15} />
          </Button>
        </ScrollToTop>
      ) : null}
    </footer>
  )
}

export default withRouter(Footer)
